import { render } from "./PatientDMEVendor.vue?vue&type=template&id=da834da0&ts=true"
import script from "./PatientDMEVendor.ts?vue&type=script&lang=ts&external"
export * from "./PatientDMEVendor.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__